var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 53",
    style: {
      enableBackground: "new 0 0 70 53"
    },
    xmlSpace: "preserve",
    width: 70,
    height: 53,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fd5108;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7,30.3c-2.5.4-3.7,2.2-3.7,5.4s1.7,5.4,4.2,5.4,2.3-.4,4.6-1.5v2.6c-2.7,1.3-4.3,1.6-6.6,1.6s-4.1-.6-5.4-2c-1.4-1.4-2.1-3.3-2.1-5.3,0-4.6,3.4-7.7,8.4-7.7s5.6,1.5,5.6,3.7-1.1,2.4-2.6,2.4-1.5-.2-2.3-.7v-3.9h0ZM39.6,36.4c2.2-2.8,3-3.9,3-5.3s-1.1-2.5-2.5-2.5-1.7.4-2.1.9v5.7l-3.6,4.8v-11h-3.4l-5.7,9.5v-9.5h-2l-5.2,1.3v1.3l2.8.3v11.6h3.7l5.5-9v9h4l5.6-7.1h-.1ZM7.2,32c.8,0,1.3-.2,1.7-.2,2.4,0,3.7,1.6,3.7,4.6s-1.6,5.4-4.5,5.4-.4,0-.8,0v-9.7h0ZM7.2,43.4c.9,0,1.9,0,2.4,0,4.9,0,8-3.1,8-7.8s-2.3-6.9-5.5-6.9-2.3.3-4.9,1.9v-1.9h-1.5l-5.7,1.7v1.4h2.4v16.2l-2.1.5v1.3h9.3v-1.3l-2.4-.5v-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.1,24.8h-15.5l2.6-4.4h15.5l-2.6,4.4ZM69.9,16h-15.5l-2.6,4.4h15.5l2.6-4.4Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwcLogo);
export default __webpack_public_path__ + "static/media/pwc_logo.0c986018018d206ee681c6b859853c3e.svg";
export { ForwardRef as ReactComponent };